module.exports = __webpack_public_path__ + "static/komal-fb344f7638fb3589eb76af9c195ead5f.jpg";